<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Old User Used Points'
                    : 'Deleted Old User Used Points'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/old-user-used-points/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/old-user-used-points/upload"
                >
                  <v-icon dark> mdi-upload </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row align="center">
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.status = null), (page = 1)"
                    label="Status"
                    hide-details="auto"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-btn color="primary" @click="updatePoints">
                    Update Points
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="min-height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: 130px">Date</th>
                      <th class="text-left" style="min-width: 130px">Phone</th>
                      <th class="text-left" style="min-width: none">Points</th>
                      <th class="text-left" style="min-width: none">
                        Product Purchased
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="old_user_used_points.length != 0">
                    <tr
                      v-for="(old_user_used_point, i) in old_user_used_points"
                      :key="`old_user_used_point_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': old_user_used_points.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="old_user_used_point.status == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="primary"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Old User Used Point is Pending</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="old_user_used_point.status == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Uploaded
                            </v-chip>
                          </template>
                          <span>Old User Used Point is Uploaded</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="old_user_used_point.status == 2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              KYC Not Verified
                            </v-chip>
                          </template>
                          <span>Old User Used Point is KYC Not Verify</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="old_user_used_point.status == 3"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Not Registered
                            </v-chip>
                          </template>
                          <span>Old User Used Point is not Registered</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ formattedDate(old_user_used_point.date) || "" }}
                      </td>
                      <td>
                        {{ old_user_used_point.phone || "" }}
                      </td>
                      <td>
                        {{ old_user_used_point.points || "" }}
                      </td>
                      <td>
                        {{ old_user_used_point.product || "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="handleStatus(old_user_used_point)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Old User Used Point</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/old-user-used-points/${encryptIt(
                                  old_user_used_point.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Old User Used Point</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="restoreData(old_user_used_point.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this old user data</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                rounded
                v-model="page"
                :length="paginationLength"
                :total-visible="10"
              >
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_old_user_used_point" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Old User Used Point deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_old_user_used_point = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_old_user_used_point" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Old User Used Point restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_old_user_used_point = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Confirmation Dialog Component -->
      <ConfirmationDialog
        :show.sync="dialog"
        :title="dialogTitle"
        :message="dialogMessage"
        :icon="dialogIcon"
        :color="dialogColor"
        @confirm="confirmApproval"
      />

      <!-- Verified Dialog Component -->
      <v-dialog v-model="showVerifyDialog" max-width="900px" persistent>
        <v-card elevation="12" class="rounded-xl">
          <v-card-title class="text-h6 font-weight-bold blue--text">
            <v-icon color="primary" class="mr-2">mdi-check-decagram</v-icon>
            Verification Result Summary
          </v-card-title>

          <v-divider class="my-1"></v-divider>

          <v-card-text class="pt-4">
            <v-tabs
              v-model="verifyTab"
              color="primary"
              centered
              slider-color="primary"
              class="rounded-lg mb-4"
            >
              <v-tab> <v-icon left>mdi-cloud-upload</v-icon> Uploading </v-tab>
              <v-tab> <v-icon left>mdi-cloud-upload</v-icon> Uploaded </v-tab>
              <v-tab>
                <v-icon left>mdi-account-alert</v-icon> KYC Not Verified
              </v-tab>
              <v-tab>
                <v-icon left>mdi-account-remove</v-icon> Not Registered
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="verifyTab">
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.uploading"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.uploaded"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.kycNotVerified"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
              <v-tab-item>
                <v-data-table
                  :headers="headers"
                  :items="formattedResults.notRegistered"
                  dense
                  class="elevation-1 rounded-lg"
                ></v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn color="red lighten-1" text @click="showVerifyDialog = false">
              <v-icon left>mdi-close</v-icon> Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Updated Point Dialog -->
      <v-dialog v-model="showUpdatedPointDialog" max-width="700">
        <v-card rounded="rounded-xl" elevation="12" class="pa-4">
          <v-card-title
            class="text-h6 font-weight-bold primary--text d-flex align-center"
          >
            <v-icon left class="mr-2" color="success">mdi-check-circle</v-icon>
            Update Points Summary
          </v-card-title>

          <v-divider class="my-2"></v-divider>

          <v-card-text class="d-flex flex-column gap-4">
            <v-chip color="success" class="ma-2" large>
              ✅ Updated Users: {{ updateResult.updatedCount }}
            </v-chip>

            <v-chip color="warning" class="ma-2" large>
              ⚠️ Skipped Users: {{ updateResult.skippedCount }}
            </v-chip>

            <div
              v-if="
                updateResult.skippedDetails &&
                updateResult.skippedDetails.length
              "
              class="mt-4"
            >
              <v-divider class="my-2"></v-divider>
              <h3 class="subtitle-1 font-weight-medium">Skipped Details:</h3>
              <v-list dense>
                <v-list-item
                  v-for="(entry, index) in updateResult.skippedDetails"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="warning">mdi-alert-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">
                      <strong>{{ entry.phone }}</strong
                      >: {{ entry.reason }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>

          <v-divider class="my-2"></v-divider>

          <v-card-actions class="justify-end">
            <v-btn color="primary" text @click="showUpdatedPointDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  name: "OldUserDatasPage",
  data() {
    return {
      filter: {
        is_active: "",
        search_keyword: "",
        show_deleted: false,
        status: false,
      },
      old_user_used_points: [],
      statuses: [
        { id: "", text: "STATUS", value: "" },
        { id: 0, text: "PENDING", value: 0 },
        { id: 1, text: "UPLOADED", value: 1 },
      ],
      ExportOldUserDataTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_old_user_used_point: false,
      is_deleted_old_user_used_point: false,
      is_restored_old_user_used_point: false,

      selectedUserDataId: null,
      dialog: false,
      dialogTitle: "",
      dialogMessage: "",
      dialogIcon: "",
      dialogColor: "",

      showUpdatedPointDialog: false,
      updateResult: {
        updatedCount: 0,
        skippedCount: 0,
        skippedDetails: [], // [{ phone: '1234567890', reason: '...' }]
      },
      showVerifyDialog: false,
      verifyTab: 0,
      formattedResults: {
        uploaded: [],
        kycNotVerified: [],
        notRegistered: [],
      },
      headers: [
        { text: "Phone Number", value: "phone" },
        { text: "Sales Count", value: "count" },
      ],
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;

      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.status = this.filter.status || "";

      let query = new URLSearchParams({
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        ...this.filter,
      });

      await axios
        .get(`old_user_used_points?${query}`)
        .then((response) => {
          this.old_user_used_points = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`old_user_used_point_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async restoreData(id) {
      this.restore_old_user_used_point = true;
      await axios
        .post(`/old_user_used_points/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_old_user_used_point = false;
          this.is_restored_old_user_used_point = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async deleteData(id) {
      await axios
        .post(`/old_user_used_points/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    handleStatus(data) {
      this.dialogTitle = "Delete Data";
      this.dialogMessage = "Are you sure you want to delete this user data?";

      this.dialogIcon = "mdi-alert-circle-outline";

      this.dialogColor = "red";

      this.selectedUserDataId = data.id;
      this.dialog = true; // Open dialog
    },
    async confirmApproval() {
      await axios
        .post(
          `/old_user_used_points/delete/${this.encryptIt(
            this.selectedUserDataId
          )}`
        )
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async updatePoints() {
      try {
        const response = await axios.get("/old_user_used_points/update_points");
        const data = response.data.data;

        this.updateResult.updatedCount = data.updated_count.length;
        this.updateResult.skippedCount = data.skipped_count.length;

        // Build detailed list of skipped users
        this.updateResult.skippedDetails = data.skipped_count.map((entry) => {
          const phone = Object.keys(entry)[0];
          const reason = data.skipped_reasons[phone]?.[0] || "Unknown";
          return { phone, reason };
        });

        this.showUpdatedPointDialog = true;
      } catch (error) {
        console.error("Error updating points:", error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table-header {
  font-weight: 600;
}
</style>
